import { remove as lsRemove } from 'local-storage';

import type { StorageKeys } from './keys';

export const removeFromStorage = (key: StorageKeys) => lsRemove(key);
